// Heal / repair tools retired from the screens (iter392, from the Super
// Admin Endpoint Report). The code is kept — flip to true to show again.
export const RETIRED_TOOLS_VISIBLE = false;
